import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { brandsSchema, BrandsType } from "../../../types/brands";
import TruckBrandsView from "./TruckBrandsView";

export default function TruckBrands() {
  const data = useLoaderData();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const brands: BrandsType = brandsSchema.parse(data);
  const filteredBrands = brands.filter((b) =>
    b.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <TruckBrandsView
      brands={filteredBrands}
      onClick={() => navigate(-1)}
      onChange={(text) => setSearch(text)}
    />
  );
}
